import React from 'react';
import { playbookFeatures } from '../data/content';
export function ProTacticalKit() {
  return <section className="w-full bg-ink px-5 py-16 text-white sm:px-8" data-id="element-245" data-mp="10vcynzt5tfx2">
      <div className="mx-auto w-full max-w-4xl" data-id="element-246" data-mp="1em8ejw22sxa5">
        <h2 className="text-center text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-247" data-mp="1ekycyww0l6yr">
          Pro Tactical <span className="text-ember" data-id="element-248" data-mp="1alxvpit6qcdv">Kit</span>
        </h2>
        <p className="mt-4 text-center text-base text-neutral-400" data-id="element-249" data-mp="musfv3n8vk3k">
          The system that makes every coach look like a professional
        </p>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-250" data-mp="hxjz97hqvo4f">
          {playbookFeatures.map(feature => <li key={feature.title} className="flex items-start gap-3 rounded-xl border-l-4 border-ember bg-card px-5 py-4" data-id="element-251" data-mp="vx1tw3hq1vlp">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-252" data-mp="279vv900873ri">
                ✅
              </span>
              <div data-id="element-253" data-mp="22b12p6cgi0u7">
                <p className="text-sm font-extrabold" data-id="element-254" data-mp="22bkhwfaq2b4j">{feature.title}</p>
                <p className="mt-1 text-sm text-neutral-400" data-id="element-255" data-mp="37mukxb2cezr7">{feature.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}